import { useState } from "react";
import AppPage from "../AppPage";
import globals from "../../styles/globals.module.css";
import { utilities } from "../../styles";
import { arrow_Icon } from "../../assets/icons";
import { images } from "../../styles";
import { useNavigate } from "../../hooks/useNavigate";
import { useCreateLineup, useCurrentLineupIndex } from "../../hooks/lineups";
import { useActiveDraft } from "../../hooks/drafts";
import LoadingSpinner from "../LoadingSpinner";
import { ApiError } from "../../api";
import { useCurrentPlayer } from "../../hooks/player";
import { Page } from "../../types";

function LineupDraftnamePage({
  handleLetsDraft,
}: {
  handleLetsDraft: () => void;
}) {
  const [lineupName, setLineupName] = useState("");
  const { data: playerDetails } = useCurrentPlayer();
  const { setCurrentLineupIndex } = useCurrentLineupIndex();
  const { prevPageRef, navigate } = useNavigate();
  const handleBackButton = () => {
    if (!prevPageRef) {
      navigate(Page.Welcome);
      return;
    }
    navigate(prevPageRef!.current);
  };
  const { data: activeDraft, isPending: isDraftCheckPending } =
    useActiveDraft();
  const {
    mutate: createLineup,
    isPending: isCreationPending,
    isError,
    error,
  } = useCreateLineup();

  if (
    isError &&
    error instanceof ApiError &&
    [0, 403, 500].includes(error.status)
  ) {
    throw error;
  }

  if (isError && !(error instanceof ApiError)) {
    throw error;
  }

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!activeDraft || !activeDraft.active || !("draftId" in activeDraft))
      throw new Error(
        "Unhandled Exception: Lineup Creation Page was in an invalid state",
      );
    createLineup(
      { draftId: activeDraft.draftId, name: lineupName },
      {
        onSuccess: (response) => {
          setCurrentLineupIndex(response.lineupIndex);
          handleLetsDraft();
        },
      },
    );
  }

  function renderForm() {
    return (
      <div
        className={`${utilities["flex-col"]} ${utilities["gap-20"]}`}
        style={{ alignItems: "normal" }}
      >
        <span className={globals["onboarding-draftname-header"]}>
          {playerDetails?.username ?? "Player"},
          <br />
          Let's create your Band Draft!
        </span>
        <span className={globals["onboarding-draftname-subheading"]}>
          What do you want to call your lineup?
        </span>
        <span className={globals["onboarding-draftname-description"]}>
          This is how your first lineup name will be <br /> displayed on your
          lineup roster!
        </span>
        <form
          className={`${globals["user-form"]} ${utilities["gap-20"]}`}
          onSubmit={handleSubmit}
        >
          <div className={globals["user-form__group"]}>
            <input
              value={lineupName}
              onChange={(e) => setLineupName(e.target.value)}
            />
          </div>
          <div className={globals["user-form__group"]}>
            {error && (
              <p className={globals["user-form__error"]}>{error.message}</p>
            )}
          </div>
          <div className={globals["user-form__submission"]}>
            <button
              className={globals["button-wrapper"]}
              type="submit"
              disabled={isCreationPending}
            >
              {isCreationPending ? (
                <LoadingSpinner />
              ) : (
                <div className={globals["lrg-btn"]}>Let's Draft!</div>
              )}
            </button>
          </div>
        </form>
      </div>
    );
  }

  return (
    <AppPage className={globals["page"]}>
      {isDraftCheckPending ? <LoadingSpinner /> : renderForm()}
      <button
        className={`${globals["button-wrapper"]} ${globals["back-btn--top-left"]}`}
        onClick={handleBackButton}
      >
        <div className={globals["back-btn"]}>
          <img src={arrow_Icon} alt="" className={images["back-icon"]} />
        </div>
      </button>
    </AppPage>
  );
}
export default LineupDraftnamePage;
